export class CompanyUserAddModel {
    public firstName: string;
    public lastName: string;
    public email: string;
    public phone: string;
    public role: string;
    public timeZone: string;
    public facility: string;
    public companyId: number;
    public profileImage: string;
    public sendInAppNotification: boolean;
    public sendPushNotification: boolean;
    public sendEmailNotification: boolean;
    public enableEmailNotification: boolean;
    public enableInAppNotification: boolean;
    public enablePushNotification: boolean;

    constructor() {
        this.role = '';
        this.facility = '';
        this.sendEmailNotification = true;
        this.sendInAppNotification = true;
        this.sendPushNotification = true;
        this.enableEmailNotification = true;
        this.enableInAppNotification = true;
        this.enablePushNotification = true;
    }
}
